import {AfterViewInit, Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from '@angular/router';
import {ScrollPositionService} from '../../shared/services/scroll-position.service';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  sections: any[] | undefined;
  renderer: any;

  constructor(
    public router: Router,
    renderer: Renderer2,
    private readonly scrollPositionService: ScrollPositionService
  ) {
    this.renderer = renderer;
  }

  ngOnInit(): void {
    console.log()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollPositionService.restoreScrollForUrl('/home');
    }, 100);


  }

  ngOnDestroy(): void {
    const currentPosition = this.scrollPositionService.getCurrentScrollPosition();
    this.scrollPositionService.savePosition('/home', currentPosition);

    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}
